module.exports = "/_next/static/images/jwt-35c2cfc4f860000a223263bbe0e9c0d0.png";